/* eslint-env browser */
import newHomepage from './new-homepage';
import newPricingpage from './new-pricing';

const pages = [newHomepage, newPricingpage];

export default function register() {
  pages.forEach(page => page());
}



// WEBPACK FOOTER //
// ./src/pages/ab-variants/client.js